// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-2sOMC","info":"info-1fqxn"};